// utils/policyBadges.js
export const getPolicyBadges = (policies = {}) => {
  const badges = [];

  // RETURN POLICY
  if (policies.returnPolicy) {
    if (policies.returnPolicy.includes("7")) {
      badges.push({ label: "7 Day Return", type: "return" });
    } else if (policies.returnPolicy.includes("10")) {
      badges.push({ label: "10 Day Return", type: "return" });
    } else {
      badges.push({ label: "Returns Available", type: "return" });
    }
  }

  // PROCESSING TIME (structured)
  switch (policies.processingTime) {
    case "same_day":
      badges.push({ label: "Same Day Dispatch", type: "shipping" });
      break;
    case "1_day":
      badges.push({ label: "1 Day Dispatch", type: "shipping" });
      break;
    case "2_days":
      badges.push({ label: "2 Day Dispatch", type: "shipping" });
      break;
    case "3_5_days":
      badges.push({ label: "Fast Shipping", type: "shipping" });
      break;
    case "1_week":
      badges.push({ label: "Standard Shipping", type: "shipping" });
      break;
  }

  // WARRANTY
  if (policies.warranty) {
    badges.push({
      label: policies.warranty,
      type: "warranty",
    });
  }

  return badges;
};